import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import type { VendorCtaSelectorProps } from './VendorCtaSelector';

const GubagooCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  const { ctaGubagooLabel, flowOptionGubagoo } = ctaDetails;
  return (
    <TextButton
      href=""
      variant={variant}
      key={`key_${flowOptionGubagoo}`}
      className="cbo-button"
      data-flow={flowOptionGubagoo}
      data-vin={vin}
      data-testid="gubagoo"
    >
      {ctaGubagooLabel}
    </TextButton>
  );
};

export default GubagooCta;
